import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bsc-economics-and-finance',
  templateUrl: './bsc-economics-and-finance.component.html',
  styleUrls: ['./bsc-economics-and-finance.component.scss']
})
export class BscEconomicsAndFinanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
